export const _en = {
    uid: {
        label: "Uid"
    },
    name: {
        label: "Name"
    },
    startDateConstructionPlanning: {
        label: "Start date Construction of schedules"
    },
    colorAfterConstruction: {
        label: "Color after construction date"
    },
    colorBeforeConstruction: {
        label: "Color before construction date"
    },
    labelAfterConstruction: {
        label: "Period name after construction date"
    },
    labelBeforeConstruction: {
        label: "Period name before construction date"
    },
    groups: {
        generalData: "General datas",
        planningData: "Planning schedule data"
    }
};

export const _fr = {
    uid: {
        label: "UID"
    },
    name: {
        label: "Nom"
    },
    startDateConstructionPlanning: {
        label: "Date jalon"
    },
    colorAfterConstruction: {
        label: "Couleur post jalon"
    },
    colorBeforeConstruction: {
        label: "Couleur pré jalon"
    },
    labelAfterConstruction: {
        label: "Nom de la phase post jalon"
    },
    labelBeforeConstruction: {
        label: "Nom de la phase pré jalon"
    },
    groups: {
        generalData: "Informations générales",
        planningData: "Informations de planification"
    }
};